import { AggregationField } from 'widgets/portfolioSummary/aggregation/fields/aggregationFieldPortfolio';
import { PortfolioSummaryColumn } from 'widgets/portfolioSummary/grid/portfolioSummaryGridColumns';
import { GridChartTreemapView } from 'utils/components/ViewToggleButtons/ViewToggleButtons';
import { ConfigStateWithGridSupport } from 'widgets/store/grid/reducer';
import { WidgetConfigWithHideableToolbar } from 'widgets/WidgetToolbarShowHidePanel/WidgetConfigWithHideableToolbar';
import { QuantitiesOptions } from 'utils/components/QuantitiesOptions/QuanitiesOptions';
import { WidgetConfigWithTabTitle } from 'widgets/tabTitle/WidgetConfigWithTabTitle';

export type PortfolioSummarySideNetOptions = 'side' | 'net';

export enum PortfolioSummaryConfigSchemaVersion {
    Initial,
    // Net columns added...
    Latest,
}

export interface PortfolioSummaryConfigurationState
    extends ConfigStateWithGridSupport<PortfolioSummaryColumn>,
        WidgetConfigWithHideableToolbar,
        WidgetConfigWithTabTitle {
    aggregationField: AggregationField;
    view: GridChartTreemapView;
    quantities: QuantitiesOptions;
    sideNet: PortfolioSummarySideNetOptions;
    version?: PortfolioSummaryConfigSchemaVersion;
}

export const defaultVisibleColumns: PortfolioSummaryColumn[] = [
    'groupName',
    'count',
    'orderQty',
    'tradedQty',
    'leavesQty',
    'orderedValueLoc',
    'tradedValueLoc',
    'leavesValueLoc',
    'netTradedValueLoc',
    'averagePercentageCompletion',
];

export const initialPortfolioSummaryConfiguration: PortfolioSummaryConfigurationState =
    {
        aggregationField: 'side',
        columnWidths: { groupName: 45 },
        view: 'grid',
        quantities: 'ordered',
        sideNet: 'side',
        visibleColumns: defaultVisibleColumns,
        sort: [],
    };
